import { Component, OnInit, inject } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-ljoh-online',
  templateUrl: './ljoh-online.html',
  styleUrl: './ljoh-online.scss',
})
export class LjohOnline implements OnInit {
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    this.commonService.showTitle('/assets/titles/custom.jpg');
  }
}
